import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URI } from 'src/environments/app.config';
import { Observable } from 'rxjs/Observable';
import { BaseService } from 'src/app/services/base.service';
import { ProviderCreateRequest } from 'src/app/services/models/provider/provider.create.request.model'
import {Response} from 'src/app/services/models/response.model'
import { ProviderUpdateRequest } from './models/provider/provider.update.request.model';
import { Provider } from './models/provider/provider.model';
import { ProviderSearchRequest } from './models/provider/provider.search.request.model';

@Injectable()
export class ProviderService extends BaseService {
  constructor(private _http: HttpClient) {
    super(_http);
    this.baseUrl =  API_URI.provider;
  }

  getAllProvider(): Observable<Response<Provider[]>> {
    const url = `/GetAllProvider`;
    return this.get(url)
    .map(result => new Response<Provider[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  getProviderInfo(providerID:number): Observable<Response<Provider>> {
    const url = `/GetProviderInfo/`+providerID;
    return this.get(url)
    .map(result => new Response<Provider>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  createProvider(providerDetail: ProviderCreateRequest): Observable<Response<Provider>> {
    providerDetail.ProviderCode = providerDetail.ProviderCode.trim();
    providerDetail.ProviderName = providerDetail.ProviderName.trim();
    return this.post(`/CreateProvider`, providerDetail, {})
    .map(result => new Response<Provider>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  searchProvider(data: ProviderSearchRequest): Observable<Response<Provider[]>> {
    data.ProviderName = data.ProviderName.trim();
    return this.post(`/SearchProvider`, data, {})
    .map(result => new Response<Provider[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  updateProvider(providerDetail: ProviderUpdateRequest): Observable<Response<Provider>> {
    providerDetail.ProviderName = providerDetail.ProviderName.trim();
    return this.post(`/UpdateProvider`, providerDetail, {})    
    .map(result => new Response<Provider>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }
}